import React from 'react';

/**
 * PaymentMethodsRow — payment provider badges shown in the footer.
 *
 * These are *informational* — the actual payment options are rendered by
 * Shopify on the checkout page. We show them on the storefront to set the
 * customer's expectation (no surprises at checkout) and to add trust.
 *
 * Logos are inline SVG (small, no external requests, brand-safe).
 */

const Wrap = ({ children, label }) => (
  <span
    role="img"
    title={label}
    aria-label={label}
    className="inline-flex items-center justify-center h-8 px-2.5 rounded-md bg-white border border-black/10 shadow-[0_1px_2px_rgba(0,0,0,0.04)] text-[11px] font-semibold tracking-wide text-beauty-black"
  >
    {children}
  </span>
);

const PaymentMethodsRow = () => (
  <div
    className="flex flex-wrap items-center justify-center md:justify-start gap-2"
    data-testid="footer-payment-methods"
    role="group"
    aria-label="Accepted payment methods"
  >
    <Wrap label="Visa">
      <span className="text-[11px] font-black italic text-[#1A1F71] tracking-tighter" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', letterSpacing: '-0.5px' }}>VISA</span>
    </Wrap>
    <Wrap label="Mastercard">
      <svg width="26" height="16" viewBox="0 0 152 90" aria-hidden="true">
        <circle cx="56" cy="45" r="40" fill="#EB001B"/>
        <circle cx="96" cy="45" r="40" fill="#F79E1B"/>
        <path fill="#FF5F00" d="M76 14a40 40 0 010 62 40 40 0 010-62z"/>
      </svg>
    </Wrap>
    <Wrap label="American Express">
      <span className="text-[10px] font-bold text-[#006FCF] tracking-tighter">AMEX</span>
    </Wrap>
    <Wrap label="PayPal">
      <span>
        <span className="text-[#003087] text-[11px] font-bold tracking-tight">Pay</span>
        <span className="text-[#0070BA] text-[11px] font-bold tracking-tight">Pal</span>
      </span>
    </Wrap>
    <Wrap label="Apple Pay">
      <svg width="30" height="13" viewBox="0 0 165 70" aria-hidden="true">
        <path fill="#000" d="M30 17a10 10 0 008 -5 10 10 0 00-8 5zm-2 4c-5 0 -9 3 -11 3s-6 -3 -10 -3c-5 0 -9 3 -12 7 -5 9 -1 22 4 29 2 4 5 8 9 8 3 0 5 -2 9 -2 4 0 5 2 9 2 4 0 6 -4 8 -8 3 -5 4 -10 4 -10s-7 -3 -7 -11c0 -7 6 -10 6 -10s-3 -5 -9 -5zM75 17v37h6V41h8c8 0 13 -5 13 -12 0 -7 -5 -12 -13 -12H75zm6 5h7c5 0 8 3 8 7 0 5 -3 8 -8 8h-7v-15zM112 54c4 0 8 -2 9 -5h1v5h6V35c0 -6 -5 -11 -12 -11s-12 5 -12 11h6c0 -3 2 -5 6 -5s6 2 6 5v2l-9 1c-6 0 -10 4 -10 9 0 5 4 8 9 8zm2 -4c-3 0 -5 -1 -5 -4 0 -2 2 -4 6 -5l8 -1v3c0 4 -4 7 -9 7zM135 65c6 0 9 -2 12 -8l13 -33h-6l-9 25 -8 -25h-7l12 32 -1 3c-1 4 -3 5 -7 5h-2v5z"/>
      </svg>
    </Wrap>
    <Wrap label="Afterpay">
      <span className="text-[#B2FCE4] bg-black px-1.5 py-0.5 rounded-sm text-[10px] font-bold tracking-tight">afterpay</span>
    </Wrap>
    <Wrap label="Klarna">
      <span className="text-black bg-[#FFA8CD] px-1.5 py-0.5 rounded-sm text-[10px] font-bold tracking-wide">Klarna.</span>
    </Wrap>
    <Wrap label="Zip Pay (shop only)">
      <span className="text-white bg-[#1A0DAB] px-1.5 py-0.5 rounded-sm text-[10px] font-bold tracking-wide">zip</span>
    </Wrap>
    <Wrap label="Shop Pay">
      <span className="text-white bg-[#5A31F4] px-1.5 py-0.5 rounded-sm text-[10px] font-bold tracking-wide">Shop Pay</span>
    </Wrap>
  </div>
);

export default PaymentMethodsRow;
